import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button, Input } from 'reactstrap';
import { Link } from "react-router-dom";
import { TableActions, PageTitle } from '../../../components';
import { Filters, Utils, isSuperAdmin } from '../../../services/';
import matchSorter from 'match-sorter';
import _ from 'lodash';

import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css'

import './StudentsList.css';
import { loadGroups, loadStudents } from '../../../redux/modules';
import Table from '../../../components/Table/Table';

import Icon from '@mdi/react';
import {
    mdiFaceMan,
    mdiFaceWoman,
    mdiCheckDecagramOutline,
    mdiAlertCircleOutline
} from '@mdi/js';


const StudentsList = props => {
    const dispatch = useDispatch();

    const { groups } = useSelector(state => state.groups);

    useEffect(() => {
        dispatch(loadGroups());
        dispatch(loadStudents());
    }, [])

    const { t } = useTranslation();
    const {
        students,
        inactive_students,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.students);

    const default_lang = Utils.default_lang();

    const columns = React.useMemo(() =>[{
        Header: t('students.lastname'),
        accessor: "lastname",
        filterMethod: Filters.textFilterMethod("rfullname"),
        Filter: Filters.textFilter,
        filterAll: true,
        width: '30%',
        Cell: row => (
            <strong>
                <Icon path={ row.original?.gender === 'F' ? mdiFaceWoman : mdiFaceMan } size={1} />&nbsp;
                { row.value }
            </strong>
        )
    }, {
        Header: t('students.firstname'),
        accessor: "firstname",
        filterMethod: Filters.textFilterMethod("firstname"),
        Filter: Filters.textFilter,
        width: '30%',
        filterAll: true,
    }, {
        Header: t('students.age'),
        accessor: "age",
        filterMethod: Filters.textFilterMethod("age"),
        Filter: Filters.textFilter,
        filterAll: true,
        width: '10%',
        className: 'text-center',
        Cell: row => row.value + ' ' + t('common.age_years')
    }, {
        Header: t('students.enrolment'),
        accessor: "enrolment.status",
        width: '10%',
        Cell: row => (
            <div className="text-center">
                <Icon path={ row.value === 'ok' ? mdiCheckDecagramOutline : mdiAlertCircleOutline } size={1} />
            </div>
        )
    }, {
        Header: t('students.group'),
        accessor: 'group.id',
        width: '10%',
        filterMethod: Filters.textFilterMethod("group.id"),
        Filter: Filters.groupsFilter(groups),
        filterAll: true,
        Cell: row => <strong>{ row.row?.original?.group?.name }</strong>
    }, {
        Header: t('common.actions'),
        accessor: "id",
        width: '10%',
        filterable: false,
        className: 'text-center',
        Cell: row => <TableActions name="students" id={row.value} />
    }], [groups]);

    const actions =
    <div>
        <Button tag={Link} to="/students/new" color="success" size="sm">
            <i className="fa fa-plus"></i>&nbsp;{t('students.add_a_student')}
        </Button>
    </div>;

    return (
        <div className="StudentsList">
            <PageTitle icon="students" title={t('students.student_plural')} actions={ actions } />
            { students && (
                <Table
                    id="studentsTable"
                    data={ students }
                    columns={ columns }
                    color="light" striped hover bordered sm responsive
                />
            )}
        </div>
    );
}

export default StudentsList;
